// lureo-docs#253: every query was a single-shot fetch with no timeout; one transient
// network blip on any of the dashboard's parallel round-trips failed that load, hitting
// distant and mobile-network users hardest. Reads retry with backoff + jitter; writes
// never retry (a blind retry on POST/PATCH/DELETE could double-write). fetch only
// rejects on network-level failures or our own timeout abort; HTTP error statuses
// resolve normally and are never retried here.
const QUERY_TIMEOUT_MS = 10000;
const READ_RETRIES = 2;
const RETRY_BASE_DELAY_MS = 300;

// `timeoutMs` null sends with no client abort, for a long write the server should be left to finish.
export async function fetchWithResilience(
  input: string | Request,
  init: RequestInit,
  timeoutMs: number | null = QUERY_TIMEOUT_MS,
): Promise<Response> {
  const method = init.method ?? (typeof input === 'string' ? 'GET' : input.method);
  const attempts = method === 'GET' ? READ_RETRIES + 1 : 1;

  for (let attempt = 1; ; attempt++) {
    const controller = new AbortController();
    const timeout = timeoutMs === null ? undefined : setTimeout(() => controller.abort(), timeoutMs);
    try {
      return await fetch(input, timeoutMs === null ? init : { ...init, signal: controller.signal });
    } catch (error) {
      if (attempt >= attempts) throw error;
      const backoff = RETRY_BASE_DELAY_MS * 2 ** (attempt - 1) + Math.random() * 150;
      await new Promise(resolve => setTimeout(resolve, backoff));
    } finally {
      clearTimeout(timeout);
    }
  }
}
